import { devtools } from 'zustand/middleware';
import { create } from './advnacedActions';

const initialState = {
  job: {
    details: {
      circuitJson: null,
      cost: null,
      createdOn: null,
      device: null,
      errorMessage: null,
      jobId: null,
      queueStart: null,
      resultsMetadata: null,
      run_end: null,
      runStart: null,
      runStatus: null,
      top128: null,
      updated_on: null,
    },
    isLoading: true,
    error: null,
  },
};

let jobStore = (set, get) => ({
  ...initialState,
  setJob: (job, isLoading, error = null) => set({ job: { details: job, isLoading, error } }),
  reset: () => set({ ...initialState }),
});

jobStore = devtools(jobStore, { store: 'jobStore' });

const useJobStore = create(jobStore);

export default useJobStore;
